/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientRiskMatrixMeasuresResponseDto } from '../../models/client-risk-matrix-measures-response-dto';

export interface GetMeasures$Params {
  kycProcessId: string;
  answeredBy?: 'CLIENT' | 'COMPLIANCE';
}

export function getMeasures(http: HttpClient, rootUrl: string, params: GetMeasures$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientRiskMatrixMeasuresResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getMeasures.PATH, 'get');
  if (params) {
    rb.query('kycProcessId', params.kycProcessId, {});
    rb.query('answeredBy', params.answeredBy, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientRiskMatrixMeasuresResponseDto>;
    })
  );
}

getMeasures.PATH = '/kyc/client-risk-matrix/measures';
